/**
 * @file PaddleHub 首页学习模型卡片
 * @author FengGuang(fengguang01@baidu.com)
 */

import React, {useMemo} from 'react';

import {ILearnModel, ILearnModelListItem} from '../../types';
import A from '../../../../components/a/A';

const LearnModelCards: React.FC<ILearnModel> = props => {
    const {list, linkMore} = props;

    // 限制列表必须是5个。
    const theList = useMemo(() => {
        const baseItem: ILearnModelListItem = {
            content: '',
            links: {
                label: '',
                href: ''
            },
            title: ''
        };
        const baseList = [
            baseItem,
            baseItem,
            baseItem,
            baseItem,
            baseItem
        ];
        return Object.assign(baseList, list).slice(0, 5);
    }, [list]);

    return (
        <div className="paddle-hub-learn-model-card-wrap">
            <div className="paddle-hub-learn-model-card-group clear-both">
                {theList.map((item, index) => (
                    <A
                        key={item.title || index}
                        href={item.links.href}
                        className="paddle-hub-learn-model-card"
                    >
                        <div className="paddle-hub-learn-model-card-title">
                            {item.title}
                        </div>
                        <div
                            className="paddle-hub-learn-model-card-content"
                            dangerouslySetInnerHTML={{__html: item.content}}
                        />
                        <div className="paddle-hub-learn-model-card-tags">
                            <span>{item.links.label}</span>
                        </div>
                    </A>
                ))}
            </div>
            {!!(linkMore && linkMore.label)
            && (
                <div className="paddle-hub-learn-model-card-link">
                    <a href={linkMore.href}>
                        {linkMore.label} <i className="paddle-hub-learn-model-card-right-icon" />
                    </a>
                </div>
            )}
        </div>
    );
};

export default LearnModelCards;
